import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { PlayerProfileOutput } from "types/web-app";

/**
 * Fetches player profile including poke_coins and poke_shards
 * Note: Backend endpoint needs to be created at /player-profile
 */
export const getPlayerProfile = async (accessToken: string, playerId?: string) => {
  try {
    const url = playerId ? `/player-profile?player_id=${playerId}` : "/player-profile";
    const response = await fetchWithAuth(url, accessToken);

    const data = (await response.json()) as ServiceResponse<PlayerProfileOutput>;

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

